const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';
const SESSION_KEY = 'tap_registration_session_id';
let analyticsInitialized = false;

const ensureDataLayer = () => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
};

const getSessionId = () => {
  const existingSessionId = window.sessionStorage.getItem(SESSION_KEY);

  if (existingSessionId) {
    return existingSessionId;
  }

  const sessionId = `reg_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  window.sessionStorage.setItem(SESSION_KEY, sessionId);
  return sessionId;
};

export const initializeAnalytics = () => {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined' || analyticsInitialized) {
    return;
  }

  ensureDataLayer();

  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  const existingScript = document.querySelector(
    `script[src="https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`
  );

  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false
  });
  analyticsInitialized = true;
};

export const trackEvent = (eventName, params = {}) => {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined') {
    return;
  }

  initializeAnalytics();

  if (typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', eventName, {
    ...params,
    session_id: getSessionId()
  });
};

export const trackStepView = ({
  flow,
  step,
  stepName,
  pagePath,
  pageTitle,
  status
}) => {
  trackEvent('page_view', {
    page_path: pagePath,
    page_title: pageTitle
  });

  trackEvent('registration_step_view', {
    flow,
    step,
    step_name: stepName,
    status
  });
};
